import React, { useCallback, useState, useEffect, useContext, useRef } from 'react';
import { useParams, useNavigate } from "react-router-dom";
import "../style.scss";
import Loading from '../../../components/Loading/Index';
import Requests from '../../../utils/Requests/Index';
import ProfileDetails from '../../../components/SingleProfile/ProfileDetails/Index';
import PartnerPreference from '../../../components/SingleProfile/PartnerPreference/Index';
import Profile from "../../../components/Profile/Index";
import { singleProContext } from '../../../utils/context/SingleProfileContext';
import { io } from "socket.io-client";
import Icon from 'react-icons-kit';
import { circleRight, circleLeft } from 'react-icons-kit/iconic';
// import { toast } from 'react-toastify';
//import 'react-toastify/dist/ReactToastify.css';
import { useSelector } from 'react-redux';

////toast.configure({ autoClose: 2000 });

const Index = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const { ids } = useContext(singleProContext);
    const [key, setKey] = useState("details");
    const [data, setData] = useState({});
    const [isLoading, setLoading] = useState(true);
    const [header] = useState({ headers: { Authorization: "Bearer " + localStorage.getItem('token') } });
    const partnerPre = useRef(null);
    const socket = useRef();
    const userInfo = useSelector((state) => state.user.userData);

    const fetchData = useCallback(async () => {
        setLoading(true);
        const response = await Requests.MyProfile.Single_Profile(id, header);
        if (response && response.user) setData(response.user);
        setLoading(false);
    }, [header, id]);

    useEffect(() => {
        fetchData();
    }, [fetchData, id]);

    useEffect(() => {
        socket.current = io(`${process.env.REACT_APP_API_URL}`, {
            transports: ["websocket", "polling"]
        });
    }, []);

    useEffect(() => {
        if (!isLoading) {
            socket.current.emit("profileViewed", {
                id: userInfo.userID,
                name: userInfo.name,
                image: userInfo.profilePicture,
                to: id
            });
        }
    }, [id, isLoading, userInfo]);

    let currentIndex = ids?.indexOf(id) || 0;
    const prevProfile = () => navigate(`/single-profile/${ids[currentIndex - 1]}`);
    const nextProfile = () => navigate(`/single-profile/${ids[currentIndex + 1]}`);

    if (isLoading) return <Loading />;

    return (
        <div className="matches-results-container single_profile">
            <div className="container">
                <div className="row">
                    <div className="col-12 col-lg-11 col-xxl-9 m-auto px-2">

                        <div className="card border-0 mb-3 info-card">
                            <div className="this_body d-flex justify-content-between">
                                <div className="d-flex justify-content-center align-content-center flex-column">
                                    <h6>Here are today's top matches for you. Connect with them now!</h6>
                                </div>

                                <div className="prev_next">
                                    <button
                                        disabled={currentIndex <= 0}
                                        onClick={prevProfile}
                                        className="btn"
                                    >
                                        <Icon icon={circleLeft} size={20} /> Prev
                                    </button>
                                    <button
                                        disabled={currentIndex >= (ids?.length - 1)}
                                        onClick={nextProfile}
                                        className="btn"
                                    >
                                        Next <Icon icon={circleRight} size={20} />
                                    </button>
                                </div>
                            </div>
                        </div>

                        <Profile item={data} />

                        <div className="d-flex">
                            <div className="adds_area d-none d-xl-block">
                                <img className="img-fluid" src={data.addsense} alt="addsense" />
                            </div>

                            <section className="details">
                                <button
                                    type="button"
                                    className={key === 'details' ? "btn active" : "btn"}
                                    onClick={() => setKey('details')}
                                >
                                    Details Profile
                                </button>
                                <button
                                    type="button"
                                    className={key === 'partner' ? "btn active" : "btn"}
                                    onClick={() => {
                                        setKey('partner');
                                        partnerPre.current?.scrollIntoView({ behavior: "smooth" });
                                    }}
                                >
                                    Partner Preference
                                </button>

                                <div className="boder"></div>

                                <section className="details_area">
                                    <ProfileDetails data={data} />
                                    <div ref={partnerPre}></div>
                                    <PartnerPreference data={data} />
                                </section>
                            </section>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default Index;
